import { createActionGroup, props } from '@ngrx/store';
import {
  NotificationClickEvent,
  NotificationForegroundWillDisplayEvent,
} from 'onesignal-ngx/lib/onesignal-ngx.service';

export const OneSignalActions = createActionGroup({
  source: 'One Signal',
  events: {
    'Notification Displayed': props<{ event: NotificationForegroundWillDisplayEvent }>(),
    Clicked: props<{ event: NotificationClickEvent }>(),
  },
});
